import { Typography } from '@mui/material';
import { useOrganizationConfiguration } from '../../Model/ConfigurationModel';
import { ProgressBackdrop } from '../../Shell/ProgressBackdrop';
import { useParams } from 'react-router-dom';
import { RoleEdit } from './RoleEdit';
import { useScreenTitle } from '../../Shell/ShellScreenTitle';

export function RoleEditScreen() {
  useScreenTitle('Roles');

  const { roleName } = useParams<{ roleName: string }>();
  const configuration = useOrganizationConfiguration();

  if (!configuration) {
    return <ProgressBackdrop>Loading role...</ProgressBackdrop>;
  }

  const roles = configuration?.roles;
  const selectedRole = roles?.find((role) => role.roleName === roleName);

  if (!selectedRole) {
    return (
      <Typography className="ph-unmask" align="center" sx={{ mt: 10 }}>
        Role not found.
      </Typography>
    );
  }

  return <RoleEdit roleDefinition={selectedRole} />;
}
